document.addEventListener("DOMContentLoaded", function() {

	// responzivní menu
	// ================
	let ww = document.body.clientWidth;

	const _mouseEnter = function () {
		this.classList.add('hover');
	}
	const _mouseLeave = function () {
		this.classList.remove('hover');
	}
	const _click = function () {
		this.classList.toggle('active');
		let menu = document.querySelector('.menu');

		if (window.getComputedStyle(menu).display === 'block')
			menu.style.display = 'none';
		else menu.style.display = 'block';
	}

	let adjustMenu = function() {
		if (ww < 1101) {
			let menu = document.querySelector('.menu'),
				toggle = document.querySelector('.toggleMenu');

			toggle.style.display = 'inline-block';
			if (!toggle.classList.contains("active")) {
				menu.style.display = 'none';
			} else {
				menu.style.display = 'block';
			}

			document.querySelectorAll('.menu li').forEach(function (el) {
				el.querySelector('a').removeEventListener('mouseenter', _mouseEnter);
				el.querySelector('a').removeEventListener('mouseleave', _mouseLeave);
			});

			let PRanchor = document.querySelector('.PR-anchor');
			if(typeof(PRanchor) === 'undefined' || PRanchor === null){
				let links = document.querySelectorAll('.menu li a.parent');
				links.forEach(function (el) {
					let odkaz = el.cloneNode(true);
					odkaz.classList.remove('parent');
					odkaz.classList.add('PR-anchor');
					odkaz.textContent = '';
					el.closest('li').insertBefore(odkaz, el.closest('li').firstChild);
				});
			}

			let menuAnchor = document.querySelectorAll('.menu li a.PR-anchor');
			if(menuAnchor.length){
				menuAnchor.forEach((el) => {
					el.onclick = function (e) {
						e.preventDefault();
						this.parentNode.classList.toggle('hover');
					};
				});
			}
		} else if (ww >= 1101) {
			toggleMenu();
		}
	}

	document.querySelectorAll('.menu li a').forEach(function (el) {
		let sibling = el.nextElementSibling;
		if(typeof(sibling) != 'undefined' && sibling != null)
			el.classList.add('parent');
	});

	document.querySelector('.toggleMenu').addEventListener('click', _click);
	adjustMenu();

	window.addEventListener('resize', function () {
		ww = document.body.clientWidth;
		adjustMenu();
	});
	window.addEventListener('orientationchange', function () {
		ww = document.body.clientWidth;
		adjustMenu();
	});

	function toggleMenu() {
		document.querySelector('.toggleMenu').style.display = 'none';
		document.querySelector('.menu').style.display = 'block';

		document.querySelectorAll('.menu li').forEach((el) => {
			el.classList.remove('hover');
			el.querySelector('a').removeEventListener('click', _click);
			el.addEventListener('mouseenter', _mouseEnter);
			el.addEventListener('mouseleave', _mouseLeave);
		});
	}
});